/* eslint-disable no-undef */
import axios from 'axios';
import filesaver from 'file-saver';
import getBaseUrl from './caseBaseUrl';
import { configureHttpHeaders, onSuccess, onError } from './apiHelpers';
import { VITE_MOCK_API } from 'Constants/appEnvConstants'

const baseUrl = getBaseUrl();

export function postComments(body) {
  configureHttpHeaders(axios);
  return post(`${_CASE_COMMENT_}comments/add`, body);
}
export function getComments(caseNumber) {
  configureHttpHeaders(axios);
  return getByUrl(`${_CASE_COMMENT_}comments/${caseNumber}`);
}
export function download(name, caseNumber) {
  configureHttpHeaders(axios);
  downloadFile(`${_CASE_FILE_DOWNLOAD_}case/${caseNumber}/file/${name}`)
    .then((response) => {
      filesaver.saveAs(response.data, name);
    })
    .catch((error) => {
      console.warn('Error Occured while fetching API', error);
    });
}
export function getAllCases() {
  configureHttpHeaders(axios);
  return get('casedata');
}
export function getFiles(caseNumber) {
  configureHttpHeaders(axios);
  return axios
    .get(`https://storage-management.gp.bitwise-digital.info/storage/list/case/${caseNumber}`)
    .then(onSuccess)
    .catch(onError);
}
export function getFilesByCaseId(caseNumber, caseId) {
  configureHttpHeaders(axios);
  return axios
    .get(`https://storage-management.gp.bitwise-digital.info/storage/list/case/${caseNumber}/caseid/${caseId}`)
    .then(onSuccess)
    .catch(onError);
}
export function getAllCasesByCategory(caseType) {
  configureHttpHeaders(axios);
  // eslint-disable-next-line no-param-reassign
  caseType = caseType === 'Pre-Notes' ? 'Pre-Notes - Request Response from Merchant' : caseType;
  return caseType === 'ALL' ? get('casedata/') : get(`casedata/status/${caseType}`);
}

export function getAllCaseStatus() {
  configureHttpHeaders(axios);
  return getMock('casedata/status');
}

export function apigetTimelineData(caseId) {
  configureHttpHeaders(axios);
  return get(`casedata/stages/${caseId}`);
}
export function getByCaseId(caseId) {
  configureHttpHeaders(axios);
  return get(`casedata/${caseId}`);
}

export function getCaseTypes() {
  configureHttpHeaders(axios);
  return get('casesTypes');
}

export function getCaseTemplate(caseNumber) {
  axios.defaults.headers.common.Accept = 'application/octet-stream';
  configureHttpHeaders(axios);
  const url = 'download?caseNumber=';
  const resType = 'application/pdf';
  return axios({
    method: 'get',
    url: `${__EXPORT_FILE_API}${url}${caseNumber}`,
    responseType: 'arraybuffer',
  })
    .then((response) => {
      const blob = new Blob([response.data], { type: resType });
      return blob;
    })
    .catch(onError);
}
export function downloadFile(url) {
  configureHttpHeaders(axios);
  return axios({
    method: 'get',
    url: `${url}`,
    responseType: 'blob',
  })
    .then((response) => {
      return response;
    })
    .catch(onError);
}

export function getAuthData(authorizationMasterId) {
  configureHttpHeaders(axios);
  return get(`api/v1/case-timeline/auth?authorizationMasterId=${authorizationMasterId}`);
}

export function getCaseData(caseStageId) {
  configureHttpHeaders(axios);
  return get(`api/v1/case-timeline/case?caseStageId=${caseStageId}`);
}

export function getCardBrandData(caseStageId) {
  configureHttpHeaders(axios);
  return get(`api/v1/case-timeline/scheme?caseStageId=${caseStageId}`);
}

export function getTranData(transactionMasterId) {
  configureHttpHeaders(axios);
  return get(`api/v1/case-timeline/trans?transactionMasterId=${transactionMasterId}`);
}

export function getAuthNewTabData(caseStageId) {
  configureHttpHeaders(axios);
  return get(`api/v1/case-timeline/auth?caseStageId=${caseStageId}`);
}

export function getTranNewTabData(caseStageId) {
  configureHttpHeaders(axios);
  return get(`api/v1/case-timeline/trans?caseStageId=${caseStageId}`);
}
export function getCreditTranData(transactionMasterId) {
  configureHttpHeaders(axios);
  return get(`api/v1/case-timeline/trans?referenceTransactionId=${transactionMasterId}`);
}

function post(url, body) {
  return axios.post(url, body).then(onSuccess).catch(onError);
}
function get(url) {
  return axios.get(`${baseUrl}${url}`).then(onSuccess).catch(onError);
}
function getByUrl(url) {
  return axios.get(`${url}`).then(onSuccess).catch(onError);
}
function getMock(url) {
  return axios.get(`${VITE_MOCK_API}${url}`).then(onSuccess).catch(onError);
}

export default {
  getFiles,
  getAllCases,
  getAllCasesByCategory,
  getByCaseId,
  getCaseTypes,
  apigetTimelineData,
  getAllCaseStatus,
  getCaseTemplate,
  getAuthData,
  getCaseData,
  getCardBrandData,
  getTranData,
  getAuthNewTabData,
  getTranNewTabData,
};
